<div class="container-fluid pb-5">
  <div class="container-shadow container-fluid">
    <div class="page-header">
      <h2 class="pt-3">Setting Groups</h2>
    </div>
    <hr />
    <div class="row">
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            <a style="cursor: pointer" (click)="toggleForm()"><i class="fas" [ngClass]="{ 'fa-plus-circle': !addingSettingGroup, 'fa-minus-circle': addingSettingGroup }"></i> New Setting Group</a>
          </div>
          <div class="card-body" *ngIf="addingSettingGroup">
            <app-setting-group-form [setting_group_id]="undefined" (formEvent)="onSettingGroupFormEvent($event)"></app-setting-group-form>
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let settingGroup of settingGroups">
              <td>{{ settingGroup.id }}</td>
              <td *ngIf="!editingSettingGroups[settingGroup.id]">{{ settingGroup.name }}</td>
              <td *ngIf="!editingSettingGroups[settingGroup.id]">
                <div class="btn-group btn-group-sm">
                  <button title="edit" type="button" class="btn btn-primary" (click)="editingSettingGroups[settingGroup.id] = true"><i class="fas fa-pencil-alt"></i></button>
                  <button title="delete" type="button" (click)="deleteSettingGroup(settingGroup)" class="btn btn-danger"><i class="fas fa-trash"></i></button>
                </div>
                &nbsp;
                <span *ngIf="!selectedSettingGroup || selectedSettingGroup.id != settingGroup.id">
                  <a style="cursor: pointer" (click)="selectedSettingGroup = settingGroup">View Setting Types</a>
                </span>
                <span *ngIf="selectedSettingGroup && selectedSettingGroup.id == settingGroup.id">
                  <strong>Setting Types <i class="fas fa-arrow-right"></i></strong>
                </span>
              </td>
              <td colspan="2" *ngIf="editingSettingGroups[settingGroup.id]">
                <app-setting-group-form [setting_group_id]="settingGroup.id" (formEvent)="onSettingGroupFormEvent($event, settingGroup)"></app-setting-group-form>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6" *ngIf="selectedSettingGroup">
        <app-setting-type-index [settingGroup]="selectedSettingGroup"></app-setting-type-index>
      </div>
    </div>
  </div>
</div>
